(function ($, Drupal, drupalSettings) {

  const eaCVErrorClass = 'text-sm text-alert-error mt-1';

  // Make clientside js validation work with Drupal ajax & MT theme.
  cvJqueryValidateOptions = {
    errorElement: 'p',
    highlight: function(element, errorClass, validClass) {
      let $input = $(element).closest('input');
      $input.addClass('error').removeClass(validClass);
      $input.siblings('label').addClass(eaCVErrorClass).removeClass(validClass);
    },
    unhighlight: function(element, errorClass, validClass) {
      let $input = $(element).closest('input');
      $input.closest('input').addClass(validClass).removeClass('error');
      $input.siblings('label').addClass(validClass).removeClass(eaCVErrorClass);
    },
    submitHandler: function(form) {
      let $submit = $(this.submitButton)
      // Let non ajax forms submit.
      if (!(this.submitButton instanceof HTMLElement) || $submit.attr('data-once') !== 'drupal-ajax') {
        return true;
      }

      $submit.trigger('submit');
    },
    ignore: '.ignore-validate, :hidden, :disabled',
    errorPlacement: function(error, element) {
      error.addClass(eaCVErrorClass).attr('role', 'alert').appendTo(element.parent());
    }
  };

  // Custom "notNone" method.
  if (typeof $.validator !== 'undefined') {
    $.validator.addMethod('notNone', function (value, element) {
      return value !== '_none'; // Ensures '_none' isn't selected
    });
  }

  Drupal.behaviors.ajaxModalForm = {
    attach: function (context, settings) {
      let close_modal = function(e) {
        // Don't capture inner clicks.
        if (this !== e.target) {
          return true;
        }

        const $dialog = $('#digitalumni-modal');
        if ($dialog.length) {
          Drupal.dialog($dialog.get(0)).close();
        }

        // Unbind dialogButtonsChange.
        $dialog.off('dialogButtonsChange');
      };

      $(once('ajax-modal-form', 'div.close-modal', context)).on('mousedown', close_modal);
      $(once('ajax-modal-form', '.close-modal-popup', context)).on('click', close_modal);

      // Attach to the cv-jquery-validate-options-update event.
      $(document).on('cv-jquery-validate-options-update', function (event, options, $form) {
        // Define custom submitHandler functionality.
        options.submitHandler = cvJqueryValidateOptions.submitHandler;
      });

    }
  };

  Drupal.AjaxCommands.prototype.reloadPage = function (ajax, response, status) {
    location.reload();
  };

})(jQuery, Drupal, drupalSettings);
